// extracted by mini-css-extract-plugin
export default {"statistics_overview":"overview_statistics_overview__lhW2-","statistics":"overview_statistics__0gm-Z","statistics_card":"overview_statistics_card__sJYaB"};